import { useState } from 'react'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { EditName } from '../common/EditName'

export const NameCell = ({ name, rowId, isHovered }) => {
  const [isEdit, setIsEdit] = useState(false)

  const openEdit = () => {
    setIsEdit(true)
  }

  const closeEdit = () => {
    setIsEdit(false)
  }

  return isEdit ? (
    <EditName name={name} closeEdit={closeEdit} />
  ) : (
    <Element className="dFlex gap1 alignItemsCenter breakWordAll">
      <Element className="cursorPointer" style={{ color: '#2C73E8' }}>
        <TextEllipsisStaticLine
          text={name}
          isI18n={false}
          tooltipMaxWidthByContent
        />
      </Element>
      <Element style={{ opacity: isHovered ? 1 : 0 }}>
        <Icon
          className="icon-edit-fill"
          style={{ fontSize: 15, color: '#D5D5D5' }}
          onClick={openEdit}
        />
      </Element>
    </Element>
  )
}
